<div class="main-panel">
  <mode-capra-search-input
    class="search-input"
    data-test="filter-search-input"
    placeholder="Search..."
    [text]="searchTerm$ | async"
    (textChange)="onSearchTermChanged($event)"
  >
  </mode-capra-search-input>
  <div class="filter-placeholder filter-placeholder-list" *ngIf="isLoading">
    <div *ngFor="let n of visibleFilterValues$ | async | slice: 0:9" class="list-item-placeholder"></div>
    <div *ngIf="showAll" class="list-item-placeholder"></div>
  </div>
  <cdk-virtual-scroll-viewport
    [style.height]="this.minimumContainerHeight"
    *ngIf="!isLoading"
    [itemSize]="itemHeight"
    class="example-viewport value-list"
  >
    <span class="option-field select-all-wrapper" *ngIf="showAll">
      <input
        #selectAllInput
        id="filter-select-all-{{ uniqueId }}"
        type="radio"
        value="Select All"
        [checked]="isAll"
        (click)="onSelectAll()"
        [class.partially-selected]="hasPartialSelection"
      />
      <label class="option-label inline-icon" for="filter-select-all-{{ uniqueId }}">
        <span>(All)</span>
      </label>
    </span>
    <ng-container *cdkVirtualFor="let value of visibleFilterValues$ | async; index as i; trackBy: trackByValue">
      <span class="option-field">
        <input
          id="filter-{{ i }}-{{ uniqueId }}"
          type="radio"
          [value]="value.value"
          [checked]="isSelected(value.selected)"
          (change)="onSelectItem(value.value)"
        />
        <label class="option-label inline-icon" for="filter-{{ i }}-{{ uniqueId }}">
          <span
            [class.excluded-option]="value.selected && isExclude"
            [class.null-option]="value.value === null || value.value === undefined"
          >
            {{ value.label }}
          </span>
        </label>
      </span>
    </ng-container>
  </cdk-virtual-scroll-viewport>
  <div class="filter-desc" *ngIf="(searchTerm$ | async).length > 0; else noTermDesc">
    <ng-container *ngIf="(visibleFilterValues$ | async).length === 1; then single; else plural"></ng-container>
    <ng-container *ngIf="isShowRelevantValuesOnly; then relevant"></ng-container>
  </div>
</div>
<ng-template #single>
  There is 1 item containing <span>{{ searchTerm$ | async }}</span
  >.
</ng-template>
<ng-template #plural>
  There are <span>{{ (visibleFilterValues$ | async).length }}</span> items containing
  <span>{{ searchTerm$ | async }}</span
  >.
</ng-template>
<ng-template #relevant>
  <div>Additional values may be hidden due to other applied filters.</div>
</ng-template>
<ng-template #noTermDesc>
  <div class="filter-desc" *ngIf="isShowRelevantValuesOnly">
    <ng-container *ngTemplateOutlet="relevant"></ng-container>
  </div>
</ng-template>
